import request from '@/utils/request'

/**
 * 查询菜单列表
 * @param {Object} data
 * @returns
 */
 export function getMenus(params) {
  return request({
      url: '/getMenus',
      method: 'get',
      params,
  })
}


